var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6288",
    "data-name": "Groupe 6288",
    transform: "translate(0.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    transform: "translate(-0.353 0)",
    fill: "#d9e7fd",
    stroke: "#4188f2",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 43.5,
    rx: 44,
    ry: 43.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44,
    cy: 43.5,
    rx: 43.5,
    ry: 43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4461",
    "data-name": "Groupe 4461",
    transform: "translate(27.794 23.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_747",
    "data-name": "Trac\\xE9 747",
    d: "M40.127,12.963a3.625,3.625,0,0,0-5.12,0L31.376,16.6V7.034a3.6,3.6,0,0,0-1.06-2.56L26.9,1.06A3.6,3.6,0,0,0,24.343,0H3.62A3.624,3.624,0,0,0,0,3.62V37.571a3.624,3.624,0,0,0,3.62,3.62H27.756a3.624,3.624,0,0,0,3.62-3.62V26.841l8.751-8.758a3.618,3.618,0,0,0,0-5.12M27.963,26.842l-.652.652-2.56.853.853-2.56.652-.652Zm1.706-1.707-1.707-1.707,5.8-5.806,1.707,1.707ZM25.2,2.767,28.609,6.18a1.317,1.317,0,0,1,.354,1.06H24.136V2.414a1.317,1.317,0,0,1,1.06.353m2.56,36.011H3.62a1.208,1.208,0,0,1-1.207-1.207V3.62A1.208,1.208,0,0,1,3.62,2.414h18.1V8.447a1.207,1.207,0,0,0,1.207,1.207h6.034v9.358L25.4,22.576,23.7,24.282a1.207,1.207,0,0,0-.292.472L21.7,29.874A1.207,1.207,0,0,0,23.225,31.4l5.12-1.707a1.206,1.206,0,0,0,.472-.292l.146-.146v8.316a1.208,1.208,0,0,1-1.207,1.207m10.664-22.4-1.244,1.245L35.47,15.915l1.244-1.245a1.207,1.207,0,1,1,1.706,1.707",
    transform: "translate(0 0)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_748",
    "data-name": "Trac\\xE9 748",
    d: "M61.207,152.414H78.1a1.207,1.207,0,0,0,0-2.414H61.207a1.207,1.207,0,1,0,0,2.414",
    transform: "translate(-55.173 -137.932)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_749",
    "data-name": "Trac\\xE9 749",
    d: "M61.207,212.414H73.275a1.207,1.207,0,0,0,0-2.414H61.207a1.207,1.207,0,1,0,0,2.414",
    transform: "translate(-55.173 -193.105)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_750",
    "data-name": "Trac\\xE9 750",
    d: "M61.207,272.413H73.275a1.207,1.207,0,0,0,0-2.414H61.207a1.207,1.207,0,1,0,0,2.414",
    transform: "translate(-55.173 -248.278)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_751",
    "data-name": "Trac\\xE9 751",
    d: "M74.481,331.207A1.207,1.207,0,0,0,73.275,330H61.207a1.207,1.207,0,0,0,0,2.414H73.275a1.207,1.207,0,0,0,1.207-1.207",
    transform: "translate(-55.173 -303.451)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_752",
    "data-name": "Trac\\xE9 752",
    d: "M188.447,422h-7.241a1.207,1.207,0,0,0,0,2.414h7.241a1.207,1.207,0,1,0,0-2.414",
    transform: "translate(-165.519 -388.049)",
    fill: "#4188f2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.2b6cded53014649ad5ab7a9b8a73e501.svg";
export { ForwardRef as ReactComponent };